import React, { useEffect } from 'react';
import { Route, RouteProps } from 'react-router';
import get from 'lodash/get';
import { analytics, UNKNOWN_SCREEN, AnalyticsEventSource } from '@atlassian/temp-analytics';
import { GraphQLProvider, useApplicationContext, useTimeSpent } from '@css-xp/base';
import { ProxyGraphClients } from '@atlassian/temp-client-utils';
import { initialize as initMetalClient } from './initialize';
import { startGlobalPageLoadExperience } from '@css-xp/ppc-ufo';
// eslint-disable-next-line workspaces/require-dependency
import { PartnerAccount } from '@css-xp/ppc-types';
import { useLocalStorage } from 'usehooks-ts';

interface RouteWithAnalyticsProps extends RouteProps {
  source: AnalyticsEventSource;
  srcProxy?: string;
}

export const PPCRouteWithAnalytics = (props: RouteWithAnalyticsProps) => {
  const { source, srcProxy = ProxyGraphClients.ANS, ...routeProps } = props;
  const user = useApplicationContext();
  //using this instead of useParams here because routes were not updated
  const [txaId] = useLocalStorage(`${user?.atlassianAccountId}-selectedTxa`, '');
  const partnerAccounts = user.partnerAccounts;
  const selectedPartnerAccount = partnerAccounts?.find(
    (partnerAccount: PartnerAccount) => partnerAccount.transactionAccountId === txaId
  );
  useTimeSpent(source);
  useEffect(() => {
    /**
     * Starting global page load experience at the router HOC;
     * Every time a PPC page is navigated to/from,
     * this will create a new global page load experience to capture full page load
     */

    startGlobalPageLoadExperience(source);
    analytics.setGlobalPageProperties({
      source,
      pageAttributes: {
        userData: `${user.atlassianAccountId} ( ${get(selectedPartnerAccount, 'name', '')} )`,
      },
    });
    initMetalClient();

    return () => {
      analytics.setGlobalPageProperties({
        source: UNKNOWN_SCREEN,
        pageAttributes: {},
      });
    };
  }, [source]);

  return (
    <GraphQLProvider srcClient={srcProxy}>
      <Route {...routeProps} />
    </GraphQLProvider>
  );
};
